var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 18,
    viewBox: "0 0 29 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.904297 3.95251C0.904297 3.02636 1.27221 2.13814 1.9271 1.48325C2.58199 0.828362 3.47021 0.460449 4.39636 0.460449H17.4916C18.3386 0.46035 19.1567 0.768087 19.7937 1.32635C20.4307 1.88462 20.843 2.65536 20.954 3.49505L26.3841 1.08204C26.6499 0.963606 26.9411 0.913481 27.2312 0.936218C27.5213 0.958954 27.8011 1.05383 28.0452 1.21223C28.2893 1.37062 28.4899 1.58751 28.6289 1.84317C28.7678 2.09884 28.8407 2.38518 28.8408 2.67616V15.7051C28.8406 15.9958 28.7677 16.2819 28.6288 16.5374C28.49 16.7928 28.2895 17.0096 28.0457 17.1679C27.8018 17.3263 27.5223 17.4212 27.2324 17.4441C26.9426 17.467 26.6516 17.4172 26.3859 17.2992L20.954 14.8862C20.843 15.7259 20.4307 16.4966 19.7937 17.0549C19.1567 17.6131 18.3386 17.9209 17.4916 17.9208H4.39636C3.47021 17.9208 2.58199 17.5529 1.9271 16.898C1.27221 16.2431 0.904297 15.3549 0.904297 14.4287V3.95251Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCallIcon);
export default __webpack_public_path__ + "static/media/video-call-icon.90abf5b819310ede51e77c8f0300c899.svg";
export { ForwardRef as ReactComponent };